<template>
  <v-row no-gutters>
    <v-col>
      <v-card>
        <v-card-text class="pa-0">
          <v-row class="card-layout">
            <v-col cols="12" md="6">
              <v-row dense>
                <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.caseNumber') }}</dt></v-col>
                <v-col cols="8" class="pa-2"><dd>{{ courtCase.caseNumber }}</dd></v-col>
                <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.shortTitle') }}</dt></v-col>
                <v-col cols="8" class="pa-2"><dd>{{ courtCase.shortTitle }}</dd></v-col>
                <template v-if="courtCase.caseClassification">
                  <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.caseClassification') }}</dt></v-col>
                  <v-col cols="8" class="pa-2"><dd>{{ courtCase.caseClassification }}</dd></v-col>
                </template>
                <template v-if="courtCase.filedDate">
                  <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.filedDate') }}</dt></v-col>
                  <v-col cols="8" class="pa-2"><dd>{{ courtCase.filedDate | format($PACONST.DISPLAY_TYPE_DATETIME) }}</dd></v-col>
                </template>
                <template v-if="courtCase.caseStatus">
                  <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.caseStatus') }}</dt></v-col>
                  <v-col cols="8" class="pa-2"><dd>{{ courtCase.caseStatus }}</dd></v-col>
                </template>
                <template v-if="courtCase.caseStatusDate">
                  <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.caseStatusDate') }}</dt></v-col>
                  <v-col cols="8" class="pa-2">
                    <dd>
                      {{ courtCase.caseStatusDate | format($PACONST.DISPLAY_TYPE_DATETIME) }}
                    </dd>
                  </v-col>
                </template>
                <template v-for="(associatedCaseGroup,i) in courtCase.associatedCases">
                  <v-col :key="i + '_' + associatedCaseGroup.groupType" cols="4" class="pa-2">
                    <dt>{{ associatedCaseGroup.groupType }}</dt>
                  </v-col>
                  <v-col :key="i + '_caseGroupNumber'" cols="8" class="pa-2">
                    <dd>
                      <template v-for="(associatedCase, j) in associatedCaseGroup.cases">
                        <router-link :key="j + '_' + associatedCase.caseID"
                                     :to="{ name: 'caseView', params: { caseID: associatedCase.caseID }}">
                          <span class="sr-only">
                            {{ $t('global.goToCase') }}
                          </span>
                          {{ associatedCase.caseNumber }}<template v-if="associatedCase.leadCase">*</template>
                        </router-link>
                        <template v-if="(j+1) < associatedCaseGroup.cases.length">, </template>
                      </template>
                    </dd>
                  </v-col>
                </template>
                <template v-if="courtCase.tags && courtCase.tags.length > 0">
                  <v-col cols="4" class="pa-2"><dt>{{ $t('caseView.details.tags') }}</dt></v-col>
                  <v-col cols="8" class="pa-2">
                    <dd>
                      <v-chip v-for="tag in courtCase.tags" small :key="tag">{{ tag }}</v-chip>
                    </dd>
                  </v-col>
                </template>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <v-row dense>
                <template v-for="(field) in dynamicCaseFields">
                  <v-col :key="field.label" cols="4" class="pa-2"><dt>{{ field.label }}</dt></v-col>
                  <v-col :key="field.modelValue" cols="8" class="pa-2">
                    <dynamic-value tag-type="dd"
                                   :data-type="field.fieldDataTypeCode.viewFieldDataTypeValue"
                                   :value="getNestedProperty(courtCase, field.modelValue)"/>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import PAUTIL from '@/support/utility';

export default {
  props: {
    courtCase: {
      type: Object,
      required: true
    },
    dynamicCaseFields: {
      type: Array,
      required: true
    }
  },
  methods: {
    getNestedProperty (obj, property) {
      return PAUTIL.resolvePath(obj, property);
    }
  }
};
</script>
